import { render } from "./AccessDenied.vue?vue&type=template&id=065addea&scoped=true&ts=true"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"

import "./AccessDenied.vue?vue&type=style&index=0&id=065addea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065addea"]])

export default __exports__